document.addEventListener("DOMContentLoaded", function () {
    addRoles();
   // Check if the menu exists immediately
    if (document.querySelector('#meteor-desktop-nav')) {
        addRoles();
    } else {
        // Use MutationObserver to detect when the menu is added dynamically
        const observer = new MutationObserver((mutations, obs) => {
            if (document.querySelector('#meteor-desktop-nav')) {
                addRoles();
                obs.disconnect(); // Stop observing once applied
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
});


function addRoles() {
    const ul = document.querySelector('#meteor-desktop-nav');
  console.log(ul);
    if (ul) {
        ul.setAttribute('role', 'list');
        ul.querySelectorAll('li').forEach(li => li.setAttribute('role', 'listitem'));
    }
}